import axiosInstance from "./axiosInstanceV1";

/**
 * Fetch aggregate studio statistics (admin only)
 * @returns {Promise<Object>} StudioStats object
 */
export const fetchStudioStats = async () => {
	const response = await axiosInstance.get("/admin/stats");
	return response.data;
};

/**
 * Fetch public About page statistics
 * @returns {Promise<Object>} PublicAboutStats object
 */
export const fetchPublicAboutStats = async () => {
	const response = await axiosInstance.get("/public/stats/about");
	return response.data;
};
